import { uniq } from "lodash";
import { useExportWizardModalContext } from "PFApp/booking/parts/reports/top_actions_panel/export_wizard/export_wizard_modal_provider";
import { ExportField, ExportFields } from "PFApp/booking/types/export_booking";
import React, { useState } from "react";

import { ExpandableItem } from "../../../../../../components/expandable_item";
import { getCategoryTitle } from "../../../../../export_fields_utils";
import { FieldCategoryItems } from "./field_category_items";

interface FieldToggleProps {
  allExpanded: boolean;
  categoryKey: string;
  fields: ExportFields;
}

export const FieldCategory = ({ allExpanded, categoryKey, fields }: FieldToggleProps): JSX.Element => {
  const {
    updateData,
    state: {
      data: { selectedFields }
    }
  } = useExportWizardModalContext();

  const [expanded, setExpanded] = useState<boolean>(false);

  const onFieldToggleProvider = (selectedField: ExportField) => (checked: boolean) => {
    const newSelectedFields = checked
      ? uniq([...selectedFields, selectedField])
      : selectedFields.filter((field) => field.id !== selectedField.id);
    updateData({ selectedFields: newSelectedFields });
  };

  return (
    <>
      <ExpandableItem
        label={getCategoryTitle(categoryKey)}
        expanded={expanded || allExpanded}
        onExpand={() => setExpanded((prev) => !prev)}
      >
        <FieldCategoryItems
          categoryKey={categoryKey}
          fields={fields}
          onFieldToggleProvider={onFieldToggleProvider}
        />
      </ExpandableItem>
    </>
  );
};
